import React,  { useRef, useState, useEffect } from "react";
import headerImage from "../../assets/header13.jpg";
import { CopyBlock, dracula } from "react-code-blocks";

import w13_1 from "../../assets/w13-1.jpg";
import w13_2 from "../../assets/w13-2.jpg";
import w13_3 from "../../assets/w13-3.jpg";
import w13_4 from "../../assets/w13-4.jpg";
import w13_5 from "../../assets/w13-5.jpg";
import w13_6 from "../../assets/w13-6.jpg";
import w13_7 from "../../assets/w13-7.jpg";
import w13_8 from "../../assets/w13-8.jpg";
import w13_9 from "../../assets/w13-9.jpg";
import w13_10 from "../../assets/w13-10.jpg";
import w13_11 from "../../assets/w13-11.jpg";
import w13_12 from "../../assets/w13-12.jpg";
import w13_13 from "../../assets/w13-13.jpg";
import w13_14 from "../../assets/w13-14.jpg";
import w13_15 from "../../assets/w13-15.jpg";
import w13_16 from "../../assets/w13-16.jpg";
import w13_17 from "../../assets/w13-17.jpg";
import w13_18 from "../../assets/w13-18.jpg";
import w13_19 from "../../assets/w13-19.jpg";
import w13_20 from "../../assets/w13-20.jpg";
import w13_21 from "../../assets/w13-21.jpg";
import w13_22 from "../../assets/w13-22.jpg";
import w13_23 from "../../assets/w13-23.jpg";
import w13_24 from "../../assets/w13-24.jpg";
import w13_25 from "../../assets/w13-25.jpg";
import w13_26 from "../../assets/w13-26.jpg";
import w13_27 from "../../assets/w13-27.jpg";
import w13_28 from "../../assets/w13-28.jpg";
import w13_29 from "../../assets/w13-29.jpg";
import w13_30 from "../../assets/w13-30.jpg";
import w13_31 from "../../assets/w13-31.jpg";
import w13_32 from "../../assets/w13-32.jpg";
import w13_33 from "../../assets/w13-33.jpg";
import w13_34 from "../../assets/w13-34.jpg";
import w13_35 from "../../assets/w13-35.jpg";
import w13_36 from "../../assets/w13-36.jpg";
import w13_37 from "../../assets/w13-37.jpg";
import w13_38 from "../../assets/w13-38.jpg";
import w13_39 from "../../assets/w13-39.jpg";
import w13_40 from "../../assets/w13-40.jpg";
import w13_41 from "../../assets/w13-41.jpg";
import w13_42 from "../../assets/w13-42.jpg";
import w13_43 from "../../assets/w13-43.jpg";
import w13_44 from "../../assets/w13-44.jpg";
import w13_45 from "../../assets/w13-45.jpg";
import w13_46 from "../../assets/w13-46.jpg";
import w13_47 from "../../assets/w13-47.jpg";
import w13_48 from "../../assets/w13-48.jpg";
import w13_49 from "../../assets/w13-49.jpg";
import w13_50 from "../../assets/w13-50.jpg";
import w13_51 from "../../assets/w13-51.jpg";
import w13_52 from "../../assets/w13-52.jpg";

const Assignment13 = () => {

  const [markdown, setMarkdown] = useState("");

  useEffect(() => {
    fetch("/2025/labs/bottrop/students/annasophia-brokuf/static/media/Machine_Building.b80ee8f3efed5dc96ddb.md")
      .then((res) => res.text())
      .then((text) => setMarkdown(text));
  }, []);

    
  return (

    <div className="container mx-auto my-8 px-5 max-w-3xl bg-gray-100 p-8 rounded-lg shadow-md">
      {/* Header */}
      <div className="relative mb-8">
        <img
          src={headerImage}
          alt="Header"
          className="w-full h-64 object-cover rounded-lg shadow-md  object-cover filter grayscale brightness-75"
        />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4 rounded-b-lg">
          <h1 className="text-4xl font-bold text-bg-secondary"  style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 1)' }}>Week 12: Mechanical Design, Machine Design</h1>
          <p className="text-gray-300 mt-2">Published on: <span className="font-semibold">April 23, 2025</span></p>
          <div className="mt-4 flex space-x-4">

        </div>
        </div>
        </div>

<div className="text-gray-700 space-y-4 mt-6">

<p className="text-justify text-gray-700 mb-6">
Machine Building Week: Individual Contribution

On this page I present my contribution to Machine Building Week. First of all, there is a table showing my working days and the activities I carried out on them. 

</p>

<div className="overflow-x-auto mt-6">
  <table className="min-w-full table-auto border border-gray-300 rounded-lg overflow-hidden">
    <thead className="bg-teal-500 text-white">
      <tr>
        <th className="px-4 py-2 text-left">Date</th>
        <th className="px-4 py-2 text-left">Activities</th>
      </tr>
    </thead>
    <tbody className="text-gray-700">
      <tr className="border-t">
        <td className="px-4 py-2">Feb 16, 2025</td>
        <td className="px-4 py-2">Initial coordination meeting to discuss and plan the machine concept in advance of the workshop.</td>
      </tr>
      <tr className="border-t">
        <td className="px-4 py-2">Apr 8, 2025</td>
        <td className="px-4 py-2">Pre-Machine Week planning meeting at 12 PM. After work: gathering of components, initial assembly of parts, and task distribution within the team.</td>
      </tr>
      <tr className="border-t">
        <td className="px-4 py-2">Apr 11, 2025</td>
        <td className="px-4 py-2">After work: pick-up of the mainboard package (BIGTREETECH Octopus V1.1) at the FabLab. Joint work session: photographic documentation and parts listing.</td>
      </tr>
      <tr className="border-t">
        <td className="px-4 py-2">Apr 12, 2025</td>
        <td className="px-4 py-2">Programming the Marlin firmware for the mainboard; setting parameters for the planned XYZ-axis machine. Development of test code for motor and pump control. Implementation of a custom boot screen and menu.</td>
      </tr>
      <tr className="border-t">
        <td className="px-4 py-2">Apr 13, 2025</td>
        <td className="px-4 py-2">Crimping of JST-XH motor cable connectors. First operational test of motors and pump using a laboratory power supply.</td>
      </tr>
      <tr className="border-t">
        <td className="px-4 py-2">Apr 14, 2025</td>
        <td className="px-4 py-2">Experimental test to determine the optimal height for the pump. Assembly of components and cable preparation (crimping). Mounting the mainboard to DIN rail and connecting the power supply. First power-on test of the mounted mainboard with existing test code (axes not yet assembled). Testing motor directions. Team meeting: review of current status and redistribution of tasks.</td>
      </tr>
      <tr className="border-t">
        <td className="px-4 py-2">Apr 16, 2025</td>
        <td className="px-4 py-2">Home office: 3D design of the display mount and ribbon cable clips.</td>
      </tr>
      <tr className="border-t">
        <td className="px-4 py-2">Apr 17, 2025</td>
        <td className="px-4 py-2">3D printing and revision of designed parts due to minor flaws. Mounting the display onto the aluminum profile. Research on Z-axis head attachment, 3D Design of a possible head attachment and servo motor control using the Octopus V1.1.</td>
      </tr>
      <tr className="border-t">
        <td className="px-4 py-2">Apr 19, 2025</td>
        <td className="px-4 py-2">(Planned) Firmware update with final parameters (max height, travel range of base plate, max speed, drive gear ratios). Access to the machine was denied, so work was hypothetically completed: 1) Adjustment of firmware values, 2) Parameter testing and G-code calibration.</td>
      </tr>
      <tr className="border-t">
        <td className="px-4 py-2">Apr 18–20, 2025</td>
        <td className="px-4 py-2">(Planned) Creation of G-code for traversing multiple plates and simulating watering states (short burst mode and plant watering mode). Testing was not possible due to lack of machine access. Beginning of the writing process for the documentation.</td>
      </tr>
      <tr className="border-t">
        <td className="px-4 py-2">Apr 20–22, 2025</td>
        <td className="px-4 py-2">Writing of the documentation of the individual contribution</td>
      </tr>
    </tbody>
  </table>
</div>


<p className="text-justify text-gray-700 mb-4">
        As always you will find our group assignment on our
        <a 
          href="https://fabacademy.org/2025/labs/bottrop/Assignments/week12/" 
          className="text-blue-500 underline ml-1" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          group documentation page 
        </a>. 
      </p>
      

      <p className="text-2xl font-bold text-gray-800 mt-8 mb-4">
      1. Photographing the parts and creating a parts list 
      </p>

      <div className="overflow-x-auto mt-6">
  <table className="min-w-full table-auto border border-gray-300 rounded-lg overflow-hidden">
    <thead className="bg-teal-500 text-white">
      <tr>
        <th className="px-4 py-2 text-left">Part</th>
        <th className="px-4 py-2 text-left">Quantity</th>
        <th className="px-4 py-2 text-left">Price</th>
      </tr>
    </thead>
    <tbody className="text-gray-700">
      <tr className="border-t"><td className="px-4 py-2">Aluminum Profile 25 x 3 x 3</td><td className="px-4 py-2">4</td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">Aluminum Profile 35 x 3 x 3</td><td className="px-4 py-2">4</td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">Aluminum Profile 31 x 3 x 3</td><td className="px-4 py-2">4</td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">T-slot Nuts 30mm M4</td><td className="px-4 py-2"></td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">Hex Socket Head Screws</td><td className="px-4 py-2"></td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">Automatic Connectors (Screw, Cutting Nut, Hammerhead Nut)</td><td className="px-4 py-2">16</td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">Peristaltic Pump (13D020 or NKP-DC-510Y)</td><td className="px-4 py-2">1</td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">Stepper Motor SY42STH47-1684A</td><td className="px-4 py-2">2</td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">Stepper Motor</td><td className="px-4 py-2">1</td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">DIN Rail</td><td className="px-4 py-2">1</td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">Terminal Blocks for DIN Rail</td><td className="px-4 py-2">4</td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">End Terminal Block (4 Contacts Each)</td><td className="px-4 py-2">1</td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">Cover for DIN Rail</td><td className="px-4 py-2">1</td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">Connectors for Terminal Blocks</td><td className="px-4 py-2">2</td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">Micro Metal Gearmotor</td><td className="px-4 py-2">1</td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">Timing Pulleys (20 Teeth)</td><td className="px-4 py-2">3</td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">Belt Pulleys (20 Teeth)</td><td className="px-4 py-2">3</td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">Wire Strands (1.4mm)</td><td className="px-4 py-2"></td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">LED Reel W10mmx6</td><td className="px-4 py-2"></td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">Ferrules</td><td className="px-4 py-2"></td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">Anti-shock Feet</td><td className="px-4 py-2">4</td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">End Caps for Aluminum Profiles (30x30)</td><td className="px-4 py-2">4</td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">Linear Guide</td><td className="px-4 py-2"></td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">24V Power Supply</td><td className="px-4 py-2"></td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">Full Graphic Smart Controller</td><td className="px-4 py-2">1</td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">Bottle + Cap</td><td className="px-4 py-2"></td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">BIGTREETECH Octopus, V1.1</td><td className="px-4 py-2">1</td><td className="px-4 py-2"></td></tr>
      <tr className="border-t"><td className="px-4 py-2">TMC 2209 Stepper Motor Driver</td><td className="px-4 py-2">3</td><td className="px-4 py-2"></td></tr>
    </tbody>
  </table>
</div>


      <p className="text-justify text-gray-700 mb-6">
      I also picked up the package with the Octopus V1.1. mainboard from the office at the university. 
      </p>

      <p className="text-2xl font-bold text-gray-800 mt-8 mb-4">
      2. Programming the Mainboard and setup of the components
      </p>

      <p className="text-justify text-gray-700 mb-6">
      The control system of the machine is based on the BIGTREETECH Octopus V1.1 mainboard, equipped with TMC2209 stepper motor drivers and operated via a RepRap Discount Full Graphic Smart Controller.
      </p>

      <p className="text-2xl font-bold text-gray-800 mt-8 mb-4">
      2.1 Das Bigtree Octopus V1.1. Mainboard
      </p>

      <p className="text-justify text-gray-700 mb-6">
      The BIGTREETECH Octopus V1.1 is a high-performance 3D printer controller board designed for advanced motion control applications. It is based on the STM32F446 32-bit ARM Cortex-M4 microcontroller, offering fast processing capabilities and extended I/O options. The board supports up to 8 stepper motor drivers and features multiple communication interfaces, including USB, UART, SPI, and CAN. It is compatible with open-source firmware like Marlin and Klipper, and is particularly well-suited for complex, multi-axis machines requiring high-speed, real-time control.
      </p>

      <p className="text-2xl font-bold text-gray-800 mt-8 mb-4">
      2.2. TCM2209
      </p>

      <p className="text-justify text-gray-700 mb-6">
      The TMC2209 is a silent stepper motor driver developed by Trinamic, widely used in precision mechatronic systems due to its high efficiency and quiet operation. It supports up to 2A RMS current and integrates advanced features such as StealthChop2 for silent motion and SpreadCycle for optimized torque. Additionally, the driver includes sensorless homing via StallGuard4 and can be controlled via UART for real-time configuration. It is ideal for use in machines where smooth, quiet, and efficient motor control is required like 3D Printers or CNC machines.
      </p>

      <p className="text-2xl font-bold text-gray-800 mt-8 mb-4">
      2.3 RepRap Discount
      </p>

      <p className="text-justify text-gray-700 mb-6">
      The RepRap Discount Full Graphic Smart Controller is a user interface module that includes a rotary encoder, push-button, buzzer, and an ST7920-based monochrome graphical LCD display. It connects to the mainboard via SPI and is commonly used with Marlin firmware to provide offline control of 3D printers and CNC machines. The display enables real-time monitoring, parameter adjustment, and G-code execution without requiring a host computer. It is a robust and reliable interface for machine operation in standalone environments.
      </p>

      <p className="text-2xl font-bold text-gray-800 mt-8 mb-4">
      2.4 Marlin Firmware
      </p>

      <p className="text-justify text-gray-700 mb-6">
      Marlin is an open-source firmware developed for 3D printers and CNC machines using AVR or ARM-based control boards. It is written in C++ and provides a comprehensive feature set for motion planning, temperature regulation, user interface support, and machine safety. Marlin supports various hardware configurations and is highly configurable via its Configuration.h and Configuration_adv.h files. In this project, Marlin was customized to drive the BIGTREETECH Octopus board, enabling control of a multi-axis system with integrated peripheral components like stepper drivers and user interfaces.
      </p>

      <p className="text-2xl font-bold text-gray-800 mt-8 mb-4">
      2.5 Configuring and setting the Marlin software
      </p>

      <p className="text-justify text-gray-700 mb-6">
      I watched some useful youtube videos as a first impression on how to program the octopus mainboard with malin firmware.
      </p>

      <p className="text-2xl font-bold text-gray-800 mt-8 mb-4">
      2.5.1. Software Setup and Firmware Configuration
      </p>

      <p className="text-justify text-gray-700 mb-6">
      To program the BIGTREETECH Octopus V1.1 mainboard with Marlin firmware, a series of development tools and software packages had to be installed and configured. This process included downloading the latest firmware, setting up a build environment, and adjusting configuration files to match the specific hardware setup of the machine.
      </p>

      <p className="text-2xl font-bold text-gray-800 mt-8 mb-4">
      Installing Required Software
      </p>

      <p className="text-justify text-gray-700 mb-6">
      The firmware used for this project was Marlin 2.1.2.5, which was downloaded directly from the official Marlin GitHub repository:

https://github.com/MarlinFirmware/Marlin/tree/2.1.2.5

To compile and upload the firmware to the Octopus board, the Visual Studio Code (VS Code) IDE was used. The following extensions were installed via the VS Code extension manager:

PlatformIO IDE: Required for building embedded C++ projects and managing board environments.

Auto Build Marlin: A plugin designed to simplify Marlin-specific build and upload processes, including board detection and configuration selection.
After installing the extensions, the Marlin source folder was opened in VS Code, allowing access to the platformio.ini file and the relevant configuration directories.
      </p>

      <p className="text-2xl font-bold text-gray-800 mt-8 mb-4">
      Configuration of Marlin Firmware
      </p>
      
      <p className="text-justify text-gray-700 mb-6">
      The core of the firmware customization takes place in two files:

Configuration.h

Configuration_adv.h

These files define the machine’s hardware layout, motion system parameters, endstop behavior, motor driver settings, and other extended features.

In the Configuration.h file, it is important to adjust the following key settings:

#define MOTHERBOARD BOARD_BTT_OCTOPUS_V1_1

This selects the correct board variant to match the BIGTREETECH Octopus V1.1. The motor drivers used are TMC2209 modules, which are configured as follows:

#define X_DRIVER_TYPE TMC2209
#define Y_DRIVER_TYPE TMC2209
#define Z_DRIVER_TYPE TMC2209

Since the TMC2209 stepper drivers operate via UART communication by default, no special wiring is required apart from correctly placing the UART jumpers on the Octopus board, depending on the module version (as we used V1.3 I had to place the jumpers on the mainboard).
      </p>

      <p className="text-2xl font-bold text-gray-800 mt-8 mb-4">
      Custom Bootscreen
      </p>

      <p className="text-justify text-gray-700 mb-6">
      To personalize the user interface on the RepRap Discount Full Graphic Smart Controller (128x64 px LCD), a custom boot screen was created. The process included:
<ul>1. Designing a pixel art logo with dimensions of 128x64 pixels.</ul>
<ul>2. Converting the image into a C-compatible header file (_Bootscreen.h) using online tools or graphic-to-code converters.</ul>
<ul>3. Including the file in the Marlin source and enabling the custom boot screen option in the configuration.</ul>
      </p>
      <img src={w13_1}  className="rounded-lg shadow-md my-6" />

      <p className="text-2xl font-bold text-gray-800 mt-8 mb-4">
      Motion System and Axis Parameters
      </p>

      <p className="text-justify text-gray-700 mb-6">
      To ensure accurate motion control, the DEFAULT_AXIS_STEPS_PER_UNIT value was calculated based on the mechanical setup:

#define DEFAULT_AXIS_STEPS_PER_UNIT {`{ 80, 80, 80 }`}
X , Y, Z axes: GT2 belts with 20-tooth pulleys, NEMA17 stepper motors (200 steps/rev), and 1/16 microstepping →
Steps/mm = (200 × 16) / (20 × 2) = 80

The machine's build volume was later defined based on the usable area of the platform:
344 mm × 244 mm
      </p>

      <p className="text-justify text-gray-700 mb-6">
      Pump Control via G-code (FAN0)
      </p>
      
      <p className="text-justify text-gray-700 mb-6">
      The peristaltic pump is connected to the FAN0 output on the Octopus board and is controlled using standard G-code commands:
      </p>

      <p className="text-justify text-gray-700 mb-6">
      <ul>M106 P1 S255 ; Turn pump ON at full speed (PWM)</ul>
      <ul>G4 S3 ; Wait for 3 seconds</ul>
      M106 P1 S0 ; Turn pump OFF
      </p>

      <p className="text-justify text-gray-700 mb-6">
      This allows simple timed actuation of the pump directly from G-code scripts.
Later, after the peristaltic pump tests have been carried out, the correct duration for pump operation can be set in the final code for controlling the machine.
      </p>
      
      <p className="text-2xl font-bold text-gray-800 mt-8 mb-4">
      Creating a Custom Menu (LCD Interface)
      </p>

      <p className="text-justify text-gray-700 mb-6">
      To extend the functionality of the RepRap Discount Full Graphic Smart Controller, a custom menu was implemented within the Marlin firmware.
      </p>
<img src={w13_2}  className="rounded-lg shadow-md my-6" />
<p className="text-2xl font-bold text-gray-800 mt-8 mb-4">
      2.5.2 Detailed walk through Configuration.h
      </p>
      
      <p className="text-justify text-gray-700 mb-6">
      After the basic tools for editing the Marlin firmware were installed, I went through the individual subchapters of the configuration files step by step to customize the changes for our machine, which is not a 3D printer.
      </p>

      <p className="text-xl font-bold text-gray-800 mt-8 mb-4">
      Section: Getting Started
      </p>

      <p className="text-justify text-gray-700 mb-6">
      You can't really call setting the various parameters programming. It is more a matter of commenting out and in or adjusting the relevant or irrelevant parts in order to set the firmware according to your own requirements.

The settings for the boot screen and the mainboard used are located right at the beginning.
      </p>
      <img src={w13_3}  className="rounded-lg shadow-md my-6" />
      <p className="text-justify text-gray-700 mb-6">
      The Octopus V1.1 is based on a STM32 chip with several UARTs, therefore the SERIAL_PORT is set to -1 in Marlin.
      </p>
      <img src={w13_4}  className="rounded-lg shadow-md my-6" />
      <p className="text-xl font-bold text-gray-800 mt-8 mb-4">
      Section: Stepper Drivers
      </p>

      <p className="text-justify text-gray-700 mb-6">
      We use the same TMC2209 stepper drivers for all axes, which I have covered with heat sinks and mounted on the board in advance.
      </p>
      <img src={w13_5}  className="rounded-lg shadow-md my-6" />
      <p className="text-justify text-gray-700 mb-6">
      For further peripherals, #define E0_DRIVER_TYPE A4988 could be set to TMC2209 or another value in future, depending on use. E0 stands for the extruder. However, as we are controlling our water via the pump (FAN0), we do not need this.
      </p>

      <p className="text-xl font-bold text-gray-800 mt-8 mb-4">
      Section: Extruders
      </p>
    
      <p className="text-justify text-gray-700 mb-6">
      The funny thing is that we don't have an extruder on our machine. We use the 12V outputs for FAN to control the pump because, just like fans, it can be controlled simply via PWM and a voltage. Very practical!
Means: No extruder motor, no heater, no hotend - We can completely remove or comment out the settings, as they only apply to multi-extruder systems or dual-nozzle 3D printing. So we can also deactivate the PID control, temperature sensors and thermal protection functions.
      </p>
      <img src={w13_6}  className="rounded-lg shadow-md my-6" />

      <p className="text-justify text-gray-700 mb-6">
      Since our machine does not have temperature sensors or a heating bed, we can set the values to 0 at this point and simply comment out the following sections on temperature settings.
      </p>
      <img src={w13_7}  className="rounded-lg shadow-md my-6" />
      <p className="text-xl font-bold text-gray-800 mt-8 mb-4">
      Section: Endstop Settings
      </p>

      <p className="text-justify text-gray-700 mb-6">

<ul>     
Configuration for sensorless homing (in Configuration.h)
</ul> 
<ul>
Do NOT use endstops
</ul>
<ul>
Instead of physical endstops, we say Marlin:
</ul>
<ul>
“I have no buttons - homing runs via the drivers.”</ul>
Therefore we can

Sensorless homing active, no physical endstops
      </p>
      <img src={w13_8}  className="rounded-lg shadow-md my-6" />
      <img src={w13_9}  className="rounded-lg shadow-md my-6" />
      <p className="text-justify text-gray-700 mb-6">
      Since we are using sensorless homing, we need to define the homing direction. -1 means direction to minimum (left/front/bottom). (important for sensorless, so that it moves against a defined stop)
      </p>

      <p className="text-justify text-gray-700 mb-6">
      Sensorless homing must also be activated in Configuration_adv.h. More on this later.
      </p>

      <p className="text-xl font-bold text-gray-800 mt-8 mb-4">
      Section: Movement Settings
      </p>
      <img src={w13_10}  className="rounded-lg shadow-md my-6" />
      <p className="mb-4">
    The movement settings are used to calculate the belts and steps from the specifications below:
  </p>

  <ul className="list-disc pl-6 space-y-1 mb-4">
    <li><b>Pulley:</b> 20 teeth</li>
    <li><b>Belt:</b> GT2 (Pitch = 2 mm/tooth)</li>
    <li><b>Motor:</b> NEMA17 with 200 steps/revolution</li>
    <li><b>Microstepping:</b> 16 (standard for TMC2209)</li>
  </ul>

  <p className="mb-4 font-mono bg-white p-4 rounded border text-sm overflow-auto">
    // → Steps/mm = (200 × 16) / (20 × 2) = <b>80</b>
  </p>

  <p className="text-sm italic mb-4 text-gray-600">
    Formula:
  </p>
  <div className="bg-white p-4 rounded border font-mono text-sm overflow-auto">
    steps_per_mm = (motor_steps_per_rev × microstepping) / (pulley_teeth × belt_pitch)
  </div>

  <p className="mt-4">
    <b>Maximum speed</b> is specified in...
  </p>

  <img src={w13_11}  className="rounded-lg shadow-md my-6" />

      <p className="text-justify text-gray-700 mb-6">
      I have drastically reduced the speed compared to the default settings to avoid mechanical problems.
      </p>

      <p className="text-justify text-gray-700 mb-6">
      The maximum acceleration has also been significantly reduced.
      </p>
      <div className="bg-white p-4 rounded border font-mono text-sm overflow-auto">
      #define DEFAULT_MAX_ACCELERATION {`{1000,1000,50}`}
  </div>
<img src={w13_12}  className="rounded-lg shadow-md my-6" />
      <p className="text-justify text-gray-700 mb-6">
      To avoid vibrations in the machine and to make the movements smoother, S_Curve_Acceleration has also been activated.
      </p>
      <img src={w13_13}  className="rounded-lg shadow-md my-6" />
      <p className="text-xl font-bold text-gray-800 mt-8 mb-4">
      Section: Z Probe Options
      </p>

      <p className="text-justify text-gray-700 mb-6">
      Must be commented out because of sensorless homing.
      </p>
<img src={w13_14}  className="rounded-lg shadow-md my-6" />
      <p className="text-justify text-gray-700 mb-6">
      The direction of the stepper motor can be changed here if the motors are turning in the wrong direction.
      </p>
      <img src={w13_15}  className="rounded-lg shadow-md my-6" />
      <p className="text-justify text-gray-700 mb-6">
      The real values still have to be used here after the final completion of the mechanics with the linear guides and superstructures, as we cannot control the entire plate area due to the size of the heads and construction.
      </p>
      <img src={w13_16}  className="rounded-lg shadow-md my-6" />
      <p className="text-xl font-bold text-gray-800 mt-8 mb-4">
      Section: Bed leveling
      </p>
      

      <p className="text-justify text-gray-700 mb-6">
      Can also be completely commented out.
      </p>

      <p className="text-xl font-bold text-gray-800 mt-8 mb-4">
      Section: LCD and SD Support
      </p>

      <img src={w13_17}  className="rounded-lg shadow-md my-6" />
      <img src={w13_18}  className="rounded-lg shadow-md my-6" />
      <img src={w13_19}  className="rounded-lg shadow-md my-6" />
      <p className="text-xl font-bold text-gray-800 mt-8 mb-4">
      Section: Extra Features

      </p>

      <p className="text-justify text-gray-700 mb-6">
      As we are using a connection for fans for the pump, we can set the number of fans to 1 here.
      </p>

      <p className="text-2xl font-bold text-gray-800 mt-8 mb-4">
      Configuration_adv.h
      </p>

      <p className="text-justify text-gray-700 mb-6">
      I am now finished with the settings in Configuration.h and the settings for sensorless homing in Configuration_adv.h can be addressed.
      </p>
      <img src={w13_20}  className="rounded-lg shadow-md my-6" />
      <p className="text-xl font-bold text-gray-800 mt-8 mb-4">
      Custom Main Menu
      </p>
      <img src={w13_21}  className="rounded-lg shadow-md my-6" />
      <p className="text-xl font-bold text-gray-800 mt-8 mb-4">
      TMC2209 Stepper Driver
      </p>
      <img src={w13_22}  className="rounded-lg shadow-md my-6" />
      <img src={w13_23}  className="rounded-lg shadow-md my-6" />
      <p className="text-justify text-gray-700 mb-6">
      UART is automatically activated by using STEALTHCHOP_XY and Z.
      </p>
      
      <p className="text-justify text-gray-700 mb-6">
      As already done, I have set the jumpers to J16 and J17 for X_DIAG (X end stop) and Y_DIAG (Y end stop). The DIAG signal is necessary for sensorless homing and replaces the classic end stop function.
      </p>
      
      <p className="text-2xl font-bold text-gray-800 mt-8 mb-4">
      2.6 Generate Firmware and copy to SD Card
      </p>

      <p className="text-justify text-gray-700 mb-6">
      With the Marlin Firmware Auto Build tool, which can be easily installed via the extension menu in Visual Studio Code, a 'firmware.bin' can be easily created from the configured firmware, which can then be copied to a freshly formatted SD card (preferably smaller than 32GB and FAT32). This then only needs to be inserted into the mainboard for operation.
      </p>
      <img src={w13_24}  className="rounded-lg shadow-md my-6" />
      <p className="text-justify text-gray-700 mb-6">
      I wasted a bit of time trying to flash the Marlin firmware to the board via USB. This is not intended and leads to errors. However, the variant of simply copying the file to the SD card worked directly and without any problems.
      </p>

      <p className="text-xl font-bold text-gray-800 mt-8 mb-4">
      2.7 GCode
      </p>
      
      <p className="text-justify text-gray-700 mb-6">
      Initial test of the stepper motors, peristaltic pump and display
      </p>
      <img src={w13_25}  className="rounded-lg shadow-md my-6" />

      <p className="text-justify text-gray-700 mb-6">
      G-code is a machine control language commonly used for CNC machines and 3D printers. It consists of text-based instructions that tell a machine how to move, how fast to move, and when to turn functions like motors or pumps on or off.
      </p>

      <p className="text-justify text-gray-700 mb-6">
      Most commands begin with a letter, such as G for motion commands or M for machine-specific actions, followed by numbers and optional parameters:
      </p>


      <ul className="list-disc pl-6 space-y-2">
    <li>
      <code className="font-mono bg-white px-2 py-1 rounded shadow-sm">G1</code>: Performs a linear movement to a given position at a set speed (<code>F</code> = feedrate).
    </li>
    <li>
      <code className="font-mono bg-white px-2 py-1 rounded shadow-sm">G90</code>: Sets the system to absolute positioning mode.
    </li>
    <li>
      <code className="font-mono bg-white px-2 py-1 rounded shadow-sm">G4</code>: Pauses execution for a specified time (<code>S</code> for seconds).
    </li>
    <li>
      <code className="font-mono bg-white px-2 py-1 rounded shadow-sm">M106</code>: Controls a fan or pump using pulse-width modulation (PWM).
    </li>
    <li>
      <code className="font-mono bg-white px-2 py-1 rounded shadow-sm">M18</code>: Disables the stepper motors.
    </li>
  </ul>
      
      <p className="text-justify text-gray-700 mb-6">
      In this example, the machine lowers the Z-axis, moves along the X and Y axes, raises the Z-axis again, and then runs the pump for a short duration. These steps simulate a basic movement cycle with timed fluid dispensing, useful for simple automation tasks.
      </p>

      <CopyBlock
  text={`G90

; Lower the Z-axis (e.g., to 100 mm height)
G1 Z100 F600        ; Move Z-axis down at 600 mm/min
G4 S1               ; Wait for 1 second

; Move along the X-axis
G1 X200 F1200       ; Move to X = 200 mm
G4 S1               ; Wait for 1 second
G1 X0 F1200         ; Return to start position
G4 S1

; Move along the Y-axis
G1 Y200 F1200       ; Move to Y = 200 mm
G4 S1               ; Wait for 1 second
G1 Y0 F1200         ; Return to start position
G4 S1

; Raise the Z-axis again (e.g., to 0 mm)
G1 Z0 F600          ; Move Z-axis up
G4 S1               ; Wait for 1 second

; Activate pump (connected to FAN0)
M106 S255           ; Turn pump ON at full power (PWM)
G4 S3               ; Wait for 3 seconds
M106 S0             ; Turn pump OFF

; Disable all stepper motors
M18`}
  language="gcode"
  showLineNumbers={false}
  theme={dracula}
  wrapLongLines
  codeBlock
/>
<p className="text-2xl font-bold text-gray-800 mt-8 mb-4">
      3. Crimping the cables, first test run of the test GCode of the motors and the pump with laboratory power supply unit
      </p>

      <p className="text-justify text-gray-700 mb-6">
      To establish reliable connections between the stepper motors, pump, and the BIGTREETECH Octopus V1.1 mainboard, custom cables were prepared using proper crimping tools and connector housings. The process was carried out in several steps, ensuring electrical integrity and mechanical stability of the connections.
      </p>

      <p className="text-l font-bold text-gray-800 mt-8 mb-4">
      Crimping Process
      </p>
      <img src={w13_26}  className="rounded-lg shadow-md my-6" />
      <p className="text-justify text-gray-700 mb-6">
      The cable preparation began with stripping the insulation from the wire ends using a Knipex automatic wire stripper. This ensured precise and consistent stripping lengths, which is critical for proper crimp connection.
      </p>
<img src={w13_27}  className="rounded-lg shadow-md my-6" />
<p className="text-l font-bold text-gray-800 mt-8 mb-4">
      Crimping JST-XH terminals
      </p>

      <p className="text-justify text-gray-700 mb-6">
      Subsequently, the stripped wire ends were inserted into JST-XH crimp terminals and securely crimped using a precision crimping tool (PR-3254), rated for AWG 26–18 wires.
      </p>
<img src={w13_28}  className="rounded-lg shadow-md my-6" />
      <p className="text-justify text-gray-700 mb-6">
      Once crimped, the terminals were carefully inserted into 3-pin JST-XH connector housings. Proper orientation and full insertion were verified visually and by tactile feedback. The crimped connections showed no exposed strands and a clean mechanical seat in the housing.
      </p>
      <img src={w13_29}  className="rounded-lg shadow-md my-6" />
      <p className="text-justify text-gray-700 mb-6">
      The resulting cables were robust and ready for integration with the electronics. This step was crucial for the connection of motors and pump, ensuring stable signal and power transmission under load.
      </p>
<img src={w13_30}  className="rounded-lg shadow-md my-6" />
<p className="text-xl font-bold text-gray-800 mt-8 mb-4">
      Initial Test Setup
      </p>

      <p className="text-justify text-gray-700 mb-6">
      After preparing the cables, a first functional test was conducted using a laboratory power supply unit to safely power the control electronics and connected peripherals. The test setup included:
      </p>

      <p className="text-justify text-gray-700 mb-6">
      <ul className="list-disc pl-6 space-y-2">
    <li>The <b>BIGTREETECH Octopus V1.1</b> board</li>
    <li>A <b>RepRap Discount Full Graphic Smart Controller</b> (LCD)</li>
    <li>Two <b>NEMA17 stepper motors</b></li>
    <li>One <b>micro metal gear motor</b> with attached <b>peristaltic pump</b></li>
    <li><b>Custom-crimped JST-XH connections</b></li>
  </ul>
      </p>
      
      <p className="text-justify text-gray-700 mb-6">
      The test G-code was executed via the LCD interface, which triggered simple movement commands and activated the pump via M106 P1 S255. The motor directions, step behavior, and pump activation were all verified in this low-risk environment before connecting the full machine assembly.
      </p>

      <p className="text-justify text-gray-700 mb-6">
      This test confirmed that the firmware was correctly flashed, the stepper drivers (TMC2209 via UART) were operational, and the custom cabling met electrical and mechanical expectations.
      </p>
    <img src={w13_31}  className="rounded-lg shadow-md my-6" />
    <p className="text-2xl font-bold text-gray-800 mt-8 mb-4">
      4. Test Series: Determining the Optimal Z-Axis Height for the Peristaltic Pump
      </p>

      <p className="text-justify text-gray-700 mb-6">
      To ensure precise and clean water dispensing into the plant vessels or shot glasses, a series of experiments was conducted to determine the optimal vertical position of the tube outlet on the Z-axis. The goal was to identify the exact height at which the liquid could be dispensed reliably without causing splashes or uncontrolled dripping onto the machine’s base plate.
      </p>
      
      <p className="text-justify text-gray-700 mb-6">
      The setup involved a transparent test platform with predefined holes to place shot glasses filled with water. The peristaltic pump was connected via silicone tubing, and various Z-heights were manually tested using a folding ruler. This allowed the measurement of the ideal clearance between the tube outlet and the water surface in each container.
      </p>

      <p className="text-justify text-gray-700 mb-6">
      The peristaltic pump drew water from an external reservoir placed next to the machine. Each test run involved activating the pump observing the behavior of the water stream at different nozzle heights. In addition to the optimal Z-position, the pump runtime required to fill a single shot glass was also determined. This value ranged between 8.5 and 10 seconds per container.
      </p>

      <p className="text-justify text-gray-700 mb-6">
      It was found that placing the tube outlet at a maximum height of 8cm ensured optimal performance—minimizing splashing while maintaining consistent water delivery. These findings were then used to adjust the firmware-defined Z-axis movement limits and setpoints for the final version of the machine.
      </p>
<img src={w13_32}  className="rounded-lg shadow-md my-6" />
<img src={w13_33}  className="rounded-lg shadow-md my-6" />
<img src={w13_34}  className="rounded-lg shadow-md my-6" />
<p className="text-2xl font-bold text-gray-800 mt-8 mb-4">
      5. Interim status: mounting the electronic components on the machine housing
      </p>

      <p className="text-justify text-gray-700 mb-6">
      During this phase of the build, the main electronic components were mechanically integrated into the machine housing and electrically pre-connected to allow further functional testing and firmware validation.
      </p>
<img src={w13_35}  className="rounded-lg shadow-md my-6" />
<img src={w13_36}  className="rounded-lg shadow-md my-6" />
<img src={w13_37}  className="rounded-lg shadow-md my-6" />
<img src={w13_38}  className="rounded-lg shadow-md my-6" />
<img src={w13_39}  className="rounded-lg shadow-md my-6" />
      <p className="text-justify text-gray-700 mb-6">
      The process began with preparing the AC power input cable. A standard 3-core power cord was stripped, fitted with ferrules using a crimping tool, and later connected to the input terminals of the 24 V DC power supply. This ensured a secure and reliable connection for safe power distribution.
      </p>
      <p className="text-justify text-gray-700 mb-6">
      A wiring diagram was used as a reference to systematically connect the BIGTREETECH Octopus V1.1 control board to peripheral components such as stepper motors, endstops, the display module, the emergency stop button, and the peristaltic pump.

      </p>

      <p className="text-justify text-gray-700 mb-6">
      After mounting the control electronics, stepper motor cables and peripheral wiring were routed  and connected according to the wiring diagram. 
      </p>

      <p className="text-2xl font-bold text-gray-800 mt-8 mb-4">
      6. 3D design and printing
      </p>
      <p className="text-xl font-bold text-gray-800 mt-8 mb-4">
      6.1 3D print display case 
      </p>

      <p className="text-justify text-gray-700 mb-6">
      For the housing of the RepRap Discount Full Graphic Smart Controller, an existing case design was used from Thingiverse:  
      </p>

      <p className="text-justify text-gray-700 mb-6">
      https://www.thingiverse.com/thing:4776911/files
      </p>
      <p className="text-justify text-gray-700 mb-6">
      The STL file was downloaded, sliced, and printed without major modifications. The case provides a snug fit for the LCD and knob and includes openings for cable routing.
      </p>

      <p className="text-xl font-bold text-gray-800 mt-8 mb-4">
     6.2. 3D Design display holder for aluminum profile
      </p>

      <p className="text-justify text-gray-700 mb-6">

      <ul className="space-y-4 list-disc pl-6">
    <li>
      <p>
        <b>Display Holder 1:</b> Designed for mounting with a screw through the side. However, due to the installation angle, the screw could not be passed through the slot to reach the T-nut.
      </p>
    </li>
    <li>
      <p>
        <b>Display Holder 2:</b> This version was designed to twist into the profile directly, without pivot points. It could not be installed as intended, since the geometry didn't allow for insertion into the slot.
      </p>
    </li>
    <li>
      <p>
        <b>Display Holder 3:</b> Final version with rounded corners and pivot points. It can be turned into the aluminum profile and locks in securely. A key learning here was how to modify sketches using the timeline feature in Fusion 360 and "roll forward" design changes.
      </p>
    </li>
  </ul>
      </p>
      <img src={w13_40}  className="rounded-lg shadow-md my-6" />
      <p className="text-justify text-gray-700 mb-6">
      Display holder 1: Experiment 1 for screwing
      </p>
<img src={w13_41}  className="rounded-lg shadow-md my-6" />
      <p className="text-justify text-gray-700 mb-6">
      Display holder 2: Experiment 1 for turning in without pivot points
      </p>
<img src={w13_42}  className="rounded-lg shadow-md my-6" />
      <p className="text-justify text-gray-700 mb-6">
      Display holder 3
      </p>
      <p className="text-justify text-gray-700 mb-6">
      For turning into the aluminum profile with rounded corners and pivot points (Learning: Editing a sketch in Fusion with Timeline and then “fast-forwarding” to the previous point)
      </p>

      <p className="text-xl font-bold text-gray-800 mt-8 mb-4">
      6.3 Ribbon Cable Clip
      </p>

      <p className="text-justify text-gray-700 mb-6">
      A custom clip was designed to manage and guide the flat ribbon cable used for the display. The clip ensures strain relief and improves cable routing within the frame. It was modeled to fit the thickness of the frame and snap into place to hold the ribbon cables.
      </p>
      <img src={w13_43}  className="rounded-lg shadow-md my-6" />
      <img src={w13_44}  className="rounded-lg shadow-md my-6" />
      <p className="text-xl font-bold text-gray-800 mt-8 mb-4">
      6.4 Iterations
      </p>
      
      <p className="text-justify text-gray-700 mb-6">
      Here you can see some of the trial and error 3D printed parts.
      </p>
    <img src={w13_45}  className="rounded-lg shadow-md my-6" />

    <p className="text-xl font-bold text-gray-800 mt-8 mb-4">
      6.5 First Design: Z-Axis Head with Belt Attachment for Water Tube
      </p>

      <p className="text-justify text-gray-700 mb-6">
      The head for the Z-axis was developed to serve as a mounting point for the water delivery system, specifically the silicone tube coming from the peristaltic pump. The design was inspired by common GT2 belt clamps and was adapted to integrate with a linear guide-based movement system.
      </p>
<img src={w13_46}  className="rounded-lg shadow-md my-6" />
      <p className="text-justify text-gray-700 mb-6">
      The clamping mechanism grips the GT2 timing belt from both sides, using two opposing 3D-printed jaws that are fastened with a central screw. This ensures a firm connection between the belt and the Z-carriage, allowing precise vertical movement of the mounted head.
      </p>

      <p className="text-justify text-gray-700 mb-6">
      To transfer this motion to the linear guide system, a custom adapter plate was designed. The plate includes mounting holes that match the linear rail slider and connects to the belt clamp part. 
      </p>
    
      <p className="text-justify text-gray-700 mb-6">
      The head was designed to be mounted directly onto the linear guide carriage of the Z-axis, enabling controlled vertical movement. This allowed for accurate positioning of the water tube above the plants or glasses, making it possible to perform targeted watering and filling operations.
      </p>
      <img src={w13_47}  className="rounded-lg shadow-md my-6" />
      <img src={w13_48}  className="rounded-lg shadow-md my-6" />
      <img src={w13_49}  className="rounded-lg shadow-md my-6" />
      <img src={w13_50}  className="rounded-lg shadow-md my-6" />
      <img src={w13_51}  className="rounded-lg shadow-md my-6" />

      <p className="text-2xl font-bold text-gray-800 mt-8 mb-4">
      7. Control of servo motors for the bulk material chute with the Octopus Board
      </p>

      <p className="text-justify text-gray-700 mb-6">
      After researching on the Internet how I can control servo motors with a 5V voltage with the Octopus board, I came across a solution that uses the following PINs for control.
      </p>
<img src={w13_52}  className="rounded-lg shadow-md my-6" />
      <p className="text-justify text-gray-700 mb-6">
      BL Touch uses a small servo internally, which is why it can be used here and set in configuration.h to operate the bulk material chute. 
      </p>
          
      <p className="text-2xl font-bold text-gray-800 mt-8 mb-4">
      8.  GCode

      </p>

      <p className="text-justify text-gray-700 mb-6">
      Here is an example GCode, which controls the centers of the circles of the planting plate and lets the pump run for 3 seconds to irrigate them. 
      </p>

      <CopyBlock
  text={`; === Watering Mode for Plant Plate - Slow Movement ===
G90                    ; Absolute positioning
G21                    ; Set units to millimeters

; Travel height
G1 Z80 F600

; Position 1
G1 X41.15 Y17.15 F600
G1 Z70 F600
M106 P1 S255
G4 S3
M106 P1 S0
G1 Z80 F600

; Position 2
G1 X122.21 Y17.15 F600
G1 Z70 F600
M106 P1 S255
G4 S3
M106 P1 S0
G1 Z80 F600

; Position 3
G1 X203.26 Y17.15 F600
G1 Z70 F600
M106 P1 S255
G4 S3
M106 P1 S0
G1 Z80 F600

; Position 4
G1 X41.15 Y120.52 F600
G1 Z70 F600
M106 P1 S255
G4 S3
M106 P1 S0
G1 Z80 F600

; Position 5
G1 X122.21 Y120.52 F600
G1 Z70 F600
M106 P1 S255
G4 S3
M106 P1 S0
G1 Z80 F600

; Position 6
G1 X203.26 Y120.52 F600
G1 Z70 F600
M106 P1 S255
G4 S3
M106 P1 S0
G1 Z80 F600

; Position 7
G1 X41.15 Y223.89 F600
G1 Z70 F600
M106 P1 S255
G4 S3
M106 P1 S0
G1 Z80 F600

; Position 8
G1 X122.21 Y223.89 F600
G1 Z70 F600
M106 P1 S255
G4 S3
M106 P1 S0
G1 Z80 F600

; Position 9
G1 X203.26 Y223.89 F600
G1 Z70 F600
M106 P1 S255
G4 S3
M106 P1 S0
G1 Z80 F600

; Position 10
G1 X41.15 Y327.26 F600
G1 Z70 F600
M106 P1 S255
G4 S3
M106 P1 S0
G1 Z80 F600

; Position 11
G1 X122.21 Y327.26 F600
G1 Z70 F600
M106 P1 S255
G4 S3
M106 P1 S0
G1 Z80 F600

; Position 12
G1 X203.26 Y327.26 F600
G1 Z70 F600
M106 P1 S255
G4 S3
M106 P1 S0
G1 Z80 F600

; Disable motors
M18`}
  language="gcode"
  showLineNumbers={false}
  theme={dracula}
  wrapLongLines
  codeBlock
/>

<p className="text-2xl font-bold text-gray-800 mt-8 mb-4">
      Conclusion
      </p>
          
      <p className="text-justify text-gray-700 mb-6">
      This week, I deepened my understanding of Octopus board programming with Marlin, learned how to design pivot points for turnable components, and improved my systematic approach to writing G-code – combining both programming and 3D design skills.
      </p>


      <h2 className="text-2xl font-bold text-left mb-2">Downloads</h2>

      <a
    style={{ display: "block" }}
    href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/Display_Holderv3_v1.f3d"
    download
  >
    📎 Download Display Holder
  </a>
  <a
    style={{ display: "block" }}
    href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/Ribbon_Cable _Clips_v3.f3d"
    download
  >
    📎 Download Ribbon Cable Clip
  </a>
  <a
    style={{ display: "block" }}
    href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/gt2_head_v2.f3d"
    download
  >
    📎 Download Head
  </a>
  <a
    style={{ display: "block" }}
    href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/test.gcode"
    download
  >
    📎 Download GCode for Testing 
  </a>
  <a
    style={{ display: "block" }}
    href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/plant_3x4.gcode"
    download
  >
    📎 Download GCode Plant Mode
  </a>
  <a
    style={{ display: "block" }}
    href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/Configuration.h"
    download
  >
    📎 Download Configuration.h
  </a>
  <a
    style={{ display: "block" }}
    href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/Configuration_adv.h"
    download
  >
    📎 Download Configuration_adv.h
  </a>
        </div>

</div>

  );
};

export default Assignment13;
